<template>
    <div>
        <div class="padding pt-0 pb-0">
            <div class="d-flex mb-0 mt-2 ml-0">
                <div v-if="selectedBundleTypeId && selectedBundleInformationItem">
                    <b>{{ selectedBundleInformationItem.label }}</b> <small v-html="formatMessage(selectedBundleInformationItem.description)"></small>
                    <div v-if="selectedBundleInformationItem.statuses">
                        <ul>
                            <li v-for="(item, index) in selectedBundleInformationItem.statuses" :key="index">
                                <small>{{ item }}</small>
                            </li>
                        </ul>
                    </div>
                    <div class="mt-3" v-if="selectedBundleInformationItem.requirement">
                        <b>{{ selectedBundleInformationItem.requirement.label }}</b>
                        <ul>
                            <li>
                                <small>{{ selectedBundleInformationItem.requirement.description }}</small>
                            </li>
                        </ul>
                    </div>
                    <div v-if="selectedBundleInformationItem.comingSoon">
                        <b>{{ selectedBundleInformationItem.comingSoon.label }}</b>
                        <small v-if="Array.isArray(selectedBundleInformationItem.comingSoon.description)">
                            <ul>
                                <li v-for="(item, index) in selectedBundleInformationItem.comingSoon.description" :key="index">
                                    <strong>{{ item.label }}:</strong>
                                    <ul>
                                        <li>{{ item.description }}</li>
                                    </ul>
                                </li>
                            </ul>
                        </small>
                        <small v-else>{{ selectedBundleInformationItem.turnAroundTime.description }}</small>
                    </div>
                    <div v-if="selectedBundleInformationItem.turnAroundTime">
                        <b>{{ selectedBundleInformationItem.turnAroundTime.label }}</b>
                        <small v-if="Array.isArray(selectedBundleInformationItem.turnAroundTime.description)">
                            <ul>
                                <li v-for="(description, index) in selectedBundleInformationItem.turnAroundTime.description" :key="index">
                                   <small>{{ description }}</small>
                                </li>
                            </ul>
                        </small>
                        <small v-else>{{ selectedBundleInformationItem.turnAroundTime.description }}</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import complianceBundleInformationData from '../../constants/compliance-bundle-information'

export default {
    props: {
        selectedBundleTypeId: Number
    },
    computed: {
        selectedBundleInformationItem() {
            const dataArray = Object.values(complianceBundleInformationData);
            return dataArray.find(element => element.id === this.selectedBundleTypeId);
        }
    },
    methods: {
        formatMessage(message) {
            //In order to separate js from jsx we are using &lt;b&gt; and &lt;/b&gt; instead of <b> and </b> and replacing them with actual tags here
            return message.replace(/&lt;b&gt;([^&]+)&lt;\/b&gt;/g, '<b>$1</b>');
        }
    }
};
</script>
